import { configureStore } from '@reduxjs/toolkit';
import integrationsReducer from 'reducers/integrations/reducers';
import credentialsReducer from 'reducers/credentials/reducers';

export const store = configureStore({
    reducer: {
        credentials: credentialsReducer,
        integrations: integrationsReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
